import React from 'react';
import reasonsImage from '../../../../../images/verizon/openbank/reasons-img.webp';
import reasonsImageTablet from '../../../../../images/verizon/openbank/reasons-img-t.webp';
import reasonsImageMobile from '../../../../../images/verizon/openbank/reasons-img-m.webp';

const Reasons = () => {
  return (
    <div className="section reasons">
      <div className="container">

        <h2 className="section_title reasons_title color-red">
          So many reasons to start today
        </h2>

        <div className="reasons_grid">
          <div className="reasons_grid-item -plates">
            <div className="reasons_grid-inner">
              <div className="reasons_grid-inner-item">
                <div className="reasons_plate">
                  <div className="reasons_plate-icon">
                    <div className="reasons_formula color-red">10
                      <span className="small">
                        <b>x</b>
                        <sup>5</sup>
                      </span>
                    </div>
                  </div>
                  <h3 className="reasons_plate-title">
                    National savings average
                  </h3>
                  <div className="reasons_plate-text">
                    Watch your money grow faster.
                  </div>
                </div>
              </div>
              <div className="reasons_grid-inner-item">
                <div className="reasons_plate">
                  <div className="reasons_plate-icon">
                    <svg className="icon -reasons-insured">
                      <use xlinkHref="#svg_reasons-insured" />
                    </svg>
                  </div>
                  <h3 className="reasons_plate-title">
                    FDIC insured
                  </h3>
                  <div className="reasons_plate-text">
                    Your Openbank account is FDIC-insured by the federal government.
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="reasons_grid-item -image">
            <div className="reasons_image">
              <picture>
                <source srcSet={ reasonsImageMobile } media="(max-width: 768px)" />
                <source srcSet={ reasonsImageTablet } media="(max-width: 990px)" />
                <img src={ reasonsImage } alt="OpenBank" />
              </picture>
            </div>
          </div>

          <div className="reasons_grid-item -plates">
            <div className="reasons_grid-inner">
              <div className="reasons_grid-inner-item">
                <div className="reasons_plate">
                  <div className="reasons_plate-icon">
                    <svg className="icon -reasons-phone">
                      <use xlinkHref="#svg_reasons-phone" />
                    </svg>
                  </div>
                  <h3 className="reasons_plate-title">
                    24/7 access
                  </h3>
                  <div className="reasons_plate-text">
                    The Openbank mobile app makes it easy to manage your account.
                  </div>
                </div>
              </div>
              <div className="reasons_grid-inner-item">
                <div className="reasons_plate">
                  <div className="reasons_plate-icon">
                    <svg className="icon -reasons-coin">
                      <use xlinkHref="#svg_reasons-coin" />
                    </svg>
                  </div>
                  <h3 className="reasons_plate-title -nowrap">
                    Bank fees? Nope
                  </h3>
                  <div className="reasons_plate-text">
                    With no hidden charges or monthly service fees, you keep what you earn.
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>

      </div>
    </div>
  );
};

export default Reasons;
